import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import './FeedbackItem.css'
import React from 'react';

const FeedbackItem = ({ name, stars, comment }) => {
  return (
    <div className="feedbacks-item">
      <div className="shine"></div>
      <div className="feedback-top">
        <div className="feedback-header">
          <h3 className="profile-name">{name}</h3>
          <div className="feedback-stars">
            {Array.from({ length: stars }).map((_, index) => (
              <FontAwesomeIcon key={index} icon={faStar} />
            ))}
            {stars % 1 === 0.5 && <FontAwesomeIcon icon={faStarHalfAlt} />}
          </div>
        </div>
      </div>
      <div className="feedback-content">
        <span className="feedback-quote">"</span>
        <p>{comment}</p>
      </div>
    </div>
  );
};

export default FeedbackItem;
